import React from 'react';
import ReactDOM from 'react-dom/client';


// Custom theme CSS
// 

// Vendor JS
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'tiny-slider/src/tiny-slider';
import 'overlayscrollbars';
import 'choices.js';
import 'glightbox/dist/js/glightbox.min';
import 'flatpickr';
import 'dropzone';
import 'plyr';

// Custom theme JS
import './js/functions';
import App from './App';
import './styles/style.scss';
import reportWebVitals from './reportWebVitals';


const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
}

// Performance monitoring
reportWebVitals();